/**
 * UserAvatar — Colored circle with initial letter, consistent color from username.
 * Sizes: xs(24), sm(32), md(40), lg(56), xl(80)
 */
const COLORS = [
  "from-cyan-400 to-violet-500",
  "from-emerald-500 to-teal-600",
  "from-pink-500 to-rose-600",
  "from-amber-500 to-orange-600",
  "from-blue-500 to-cyan-600",
  "from-violet-500 to-fuchsia-600",
  "from-red-500 to-pink-600",
  "from-sky-500 to-blue-600",
];

function hashStr(s) {
  let h = 0;
  for (let i = 0; i < s.length; i++) h = ((h << 5) - h + s.charCodeAt(i)) | 0;
  return Math.abs(h);
}

const SIZES = { xs: "w-6 h-6 text-[9px]", sm: "w-8 h-8 text-xs", md: "w-10 h-10 text-sm", lg: "w-14 h-14 text-xl", xl: "w-20 h-20 text-3xl" };

export default function UserAvatar({ name, username, avatarUrl, size = "md", className = "" }) {
  const initial = (name || username || "?").charAt(0).toUpperCase();
  const colorIdx = hashStr(username || name || "x") % COLORS.length;

  if (avatarUrl) {
    return (
      <img src={avatarUrl} alt={name} className={`${SIZES[size]} rounded-full object-cover ${className}`} />
    );
  }

  return (
    <div className={`${SIZES[size]} rounded-full bg-gradient-to-br ${COLORS[colorIdx]} flex items-center justify-center text-white font-medium flex-shrink-0 ${className}`} data-testid="user-avatar">
      {initial}
    </div>
  );
}
